export const CUSTOM_FILTERS_TYPE_IDS = {
  ELEMENTS: 1,
  CHECKINS: 2
}
